
      export default {
        functional: true,
        render: 
      function render(_h, _vm) {
        var _c=_vm._c;return _c('svg',{class:[_vm.data.class, _vm.data.staticClass],style:([_vm.data.style, _vm.data.staticStyle]),attrs:{"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M17.03 7.47a.75.75 0 10-1.06 1.06l.72.72H1.5a.75.75 0 000 1.5h15.19l-.72.72a.75.75 0 101.06 1.06L19.56 10l-2.53-2.53z","fill":"#fff"}})])
      }
    
      }
    